module.exports = __webpack_public_path__ + "static/img/riseuplogo.67c7354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riseuplogo.svg
// module id = eHM/
// module chunks = 6